import { render, staticRenderFns } from "./highlightInfo.vue?vue&type=template&id=01954450&"
import script from "./highlightInfo.vue?vue&type=script&lang=js&"
export * from "./highlightInfo.vue?vue&type=script&lang=js&"
import style0 from "./highlightInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports